export default __webpack_public_path__ + "f2cc45e909916375ba18fd2206e96e39.svg";